import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ChevronLeft, ChevronRight, X } from "lucide-react";
import styles from "./palaciodas_delicias_roscas.module.scss";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import PalaciodasDeliciasButton from "./palaciodas_delicias_button.tsx";

const roscasImages = [
  { src: require("./src/roscas/rosca1.png"), alt: "Rosca 1" },
  { src: require("./src/roscas/rosca2.png"), alt: "Rosca 2" },
  { src: require("./src/roscas/rosca3.png"), alt: "Rosca 3" },
  { src: require("./src/roscas/rosca4.png"), alt: "Rosca 4" },
  { src: require("./src/roscas/rosca5.png"), alt: "Rosca 5" },
  { src: require("./src/roscas/rosca6.png"), alt: "Rosca 6" },
  { src: require("./src/roscas/rosca7.png"), alt: "Rosca 7" },
  { src: require("./src/roscas/rosca8.png"), alt: "Rosca 8" },
  { src: require("./src/roscas/rosca9.png"), alt: "Rosca 9" },
  { src: require("./src/roscas/rosca10.png"), alt: "Rosca 10" },
];

const Palaciodas_delicias_roscas: React.FC = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? roscasImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === roscasImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (selectedIndex !== null && event.key === "Escape") {
        setSelectedIndex(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedIndex]);

  const currentImage = roscasImages[currentIndex];
  const selectedImage =
    selectedIndex !== null ? roscasImages[selectedIndex] : null;

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.backButton}
          onClick={() => navigate("/palaciodas_delicias")}
          aria-label="Voltar"
        >
          <ArrowLeft size={22} />
        </button>

        <h1>Roscas</h1>
        <div className={styles.headerSpacer} />
      </div>

      <div className={styles.content}>
        <div className={styles.intro}>
          <p>
            Confira algumas das nossas roscas artesanais.
          </p>
        </div>

        <div className={styles.carousel}>
          <div className={styles.carouselFrame}>
            <button
              type="button"
              className={styles.carouselArrow}
              onClick={handlePrevious}
              aria-label="Imagem anterior"
            >
              <ChevronLeft size={24} />
            </button>

            <button
              type="button"
              className={styles.slideButton}
              onClick={() => setSelectedIndex(currentIndex)}
              aria-label={`Abrir ${currentImage.alt}`}
            >
              <img
                src={currentImage.src}
                alt={currentImage.alt}
                className={styles.image}
              />
            </button>

            <button
              type="button"
              className={styles.carouselArrow}
              onClick={handleNext}
              aria-label="Próxima imagem"
            >
              <ChevronRight size={24} />
            </button>
          </div>

          <div className={styles.dots}>
            {roscasImages.map((image, index) => (
              <button
                key={image.alt}
                type="button"
                className={`${styles.dot} ${index === currentIndex ? styles.activeDot : ""}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Ir para ${image.alt}`}
              />
            ))}
          </div>
        </div>

        <div className={styles.cta}>
          <PalaciodasDeliciasButton
            href="https://wa.me/5517981419297?text=Olá, vim pelo link na bio e gostaria de mais informações sobre as roscas..."
            title="Chamar no WhatsApp"
            icon={<WhatsappIcon color="#fffdf8" height="30" />}
          />
        </div>
      </div>

      {selectedImage && (
        <div
          className={styles.modalOverlay}
          onClick={() => setSelectedIndex(null)}
        >
          <div
            className={styles.modalContent}
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className={styles.modalClose}
              onClick={() => setSelectedIndex(null)}
              aria-label="Fechar imagem"
            >
              <X size={24} />
            </button>

            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className={styles.modalImage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Palaciodas_delicias_roscas;
